import React from 'react';
import { Link } from 'react-router-dom';
import { getCurrentUser } from '../../../helpers/storage';

const Bottombar = () => {
  const { publicSettings = {} } = getCurrentUser();
  const { appName, appVersion } = publicSettings;

  return (
    <div className="bottombar">
      <div className="bottombar__wrapper">
        <div className="bottombar__right">
          <Link className="bottombar__logo" to="/dashboard_default" />
          <span className="bottombar__role">
            <h5>
              {appName} 2021-2025 - Build # {appVersion}
            </h5>
          </span>
        </div>
      </div>
    </div>
  );
};

export default Bottombar;
